import { apiClient } from './api';
import { Branch } from '../types';

export const branchService = {
  // Get all branches for a device
  getDeviceBranches: async (deviceId: string): Promise<Branch[]> => {
    return apiClient.get<Branch[]>(`/branches/device/${deviceId}`);
  },

  getManualBranches: async (): Promise<Branch[]> => {
    return apiClient.get<Branch[]>('/branches/manual');
  },

  // Get single branch
  getBranch: async (branchId: string): Promise<Branch> => {
    return apiClient.get<Branch>(`/branches/${branchId}`);
  },

  // Create branch
  createBranch: async (data: Partial<Branch>): Promise<Branch> => {
    return apiClient.post<Branch>('/branches', data);
  },

  // Update branch
  updateBranch: async (branchId: string, data: Partial<Branch>): Promise<Branch> => {
    return apiClient.patch<Branch>(`/branches/${branchId}`, data);
  },

  // Delete branch
  deleteBranch: async (branchId: string): Promise<void> => {
    return apiClient.delete(`/branches/${branchId}`);
  },

  // Get Branch Occupancy
  getOccupancy: async (branchId: string): Promise<{ capacity: number; plants: any[] }> => {
    return apiClient.get<{ capacity: number; plants: any[] }>(`/branches/${branchId}/occupancy`);
  },
};
